import React from "react";
import TextareaAutosize from "react-textarea-autosize";
import classNames from "classnames";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import "components/Inputs/TextArea/TextArea.scss";

export const TextArea = ({
    className,
    id,
    label,
    error,
    success,
    disabled,
    helperText,
    placeholder,
    autosize = false,
    maxRows = 15,
    ...restProps
}) => {
    const inputId = id || uuidv4();

    const classes = classNames(
        "text-area",
        { "text-area--disabled": disabled },
        { "text-area--error": error },
        { "text-area--success": success },
        className
    );

    if(restProps.type === "hidden"){
        return <input {...restProps}/>;
    }

    return (
        <div className={classes}>
            { label && (
                <label
                    htmlFor={inputId}
                    className="text-area__label"
                >
                    {label}
                </label>
            )}

            {
                autosize && <TextareaAutosize
                    id={inputId}
                    className="text-area__input text-area__input_autosize"
                    disabled={disabled}
                    placeholder={placeholder || "Value"}
                    {...restProps}
                />
            }

            {
                !autosize && <textarea
                    id={inputId}
                    className="text-area__input"
                    disabled={disabled}
                    placeholder={placeholder || "Value"}
                    {...restProps}
                />
            }

            <div className="text-area__helper-text">{error || helperText}</div>
        </div>
    );
};

TextArea.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.object,
    inputClassName: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    handleChange: PropTypes.func,
    meta: PropTypes.object
};
